import {Directive, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Results} from '../../../core/results';
import {UsersService} from '../../../users/users.service';
import {User} from './user';

declare var $: any;

@Directive({
  selector: '[appUser]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UserDirective),
    multi: true
  }]
})
export class UserDirective implements ControlValueAccessor, OnInit {

  @Output() selected = new EventEmitter();
  @Input() private user: User;
  @Input() private role: string;
  @Input() private placeholder: string;
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: UsersService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: this.placeholder?this.placeholder:'Select User',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;

          if (that.role) {
            that.service.searchByRole(page, perPage, 'ASC', 'name', params.data.term, that.role).subscribe((ret: Results<User>) => {
              success(ret);
            });
          } else {
            that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<User>) => {
              success(ret);
            });
          }


        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.firstName+' '+obj.lastName,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.user = JSON.parse(e.params.data.id);
      that.propagateChange(that.user);
      if(that.selected){
        that.selected.emit();
      }

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.user = null;
      that.propagateChange(that.user);
      if(that.selected){
        that.selected.emit();
      }
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(user: User): void {

    this.user = user;
    this.propagateChange(this.user);
    const that = this;
    if (this.user !== undefined && this.user !== null) {
      const option = new Option(user.firstName+' '+user.lastName, JSON.stringify(user), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.user;
  }

  set value(v: any) {
    if (v !== this.user) {
      this.user = v;
      this.propagateChange(v);
    }
  }


}
